var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-list-container"},[_c('RightList',{attrs:{"list":_vm.tocWithSelect},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }